import Role from "../Role";
import User from "../User";
import FormElement, { formElement } from "./FormElement";
import UserRequest from "../requests/UserRequest";

export type UserFormState = {
    firstName: FormElement<string>;
    lastName: FormElement<string>;
    email: FormElement<string>;
    phoneNumber: FormElement<string>;
    password: FormElement<string>;
    confirmationPassword: FormElement<string>;
    companyId: FormElement<string>;
    newCompanyName: FormElement<string>;
    companyDepartmentId: FormElement<number | undefined>;
    newCompanyDepartmentName: FormElement<string>;
    roles: FormElement<Role[]>;
    receivesSms: FormElement<boolean>;
}

export function UserFormState_default(): UserFormState {
    return {
        firstName: formElement(""),
        lastName: formElement(""),
        email: formElement(""),
        phoneNumber: formElement(""),
        password: formElement(""),
        confirmationPassword: formElement(""),
        companyId: formElement(""),
        newCompanyName: formElement(""),
        companyDepartmentId: formElement(undefined),
        newCompanyDepartmentName: formElement(""),
        roles: formElement([]),
        receivesSms: formElement(false)
    }
}

export function UserFormState_fromUser(user: Partial<User>, roles: Role[]): UserFormState {
    return {
        firstName: formElement(user.firstName || ""),
        lastName: formElement(user.lastName || ""),
        email: formElement(user.email || ""),
        phoneNumber: formElement(user.phoneNumber || ""),
        password: formElement(""),
        confirmationPassword: formElement(""),
        companyId: formElement(user.companyId || ""),
        newCompanyName: formElement(""),
        companyDepartmentId: formElement(user.companyDepartmentId),
        newCompanyDepartmentName: formElement(""),
        roles: formElement(roles),
        receivesSms: formElement(user.receivesSms ?? false)
    }
}

export function UserFormState_toUserRequest(formState: UserFormState): UserRequest {
    return {
        firstName: formState.firstName.value,
        lastName: formState.lastName.value,
        email: formState.email.value,
        phoneNumber: formState.phoneNumber.value,
        password: formState.password.value || undefined,
        companyId: formState.companyId.value,
        newCompanyName: formState.newCompanyName.value,
        companyDepartmentId: formState.companyDepartmentId.value,
        newCompanyDepartmentName: formState.newCompanyDepartmentName.value,
        roles: formState.roles.value.map((r) => ({
            roleCode: r.roleCode,
            departmentId: r.departmentId
        })),
        receivesSms: formState.receivesSms.value
    };
}